import { render, staticRenderFns } from "./UploadBatch.vue?vue&type=template&id=5b4166ce"
import script from "./UploadBatch.vue?vue&type=script&lang=js"
export * from "./UploadBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports